import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function LaeyerzMap() {

    return (
        <div>
            <DHeader>Laeyerz Folder Structure</DHeader>
       
            <DText>
              The following folder structure is used in Laeyerz. This folder map will make it easier to understand the structure of the project.
            </DText>


       
        </div>
    )
}